import React, { useState } from 'react';
import { FaWhatsapp, FaEnvelope, FaPaperPlane, FaMapMarkerAlt } from 'react-icons/fa';
import "./contacto.css";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    mensaje: ''
  });
  const [showSendOptions, setShowSendOptions] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowSendOptions(true);
  };

  const generateMessage = () => {
    return `Hola Domotic Control,\n\nMi nombre es ${formData.nombre}.\n\n${formData.mensaje}\n\nPueden contactarme al teléfono: ${formData.telefono} o al correo: ${formData.email}\n\nSaludos.`;
  };

  const sendViaWhatsApp = () => {
    const message = encodeURIComponent(generateMessage());
    window.open(`https://wa.me/593992060337?text=${message}`, '_blank');
  };

  const sendViaEmail = () => {
    const subject = encodeURIComponent(`Consulta de ${formData.nombre}`);
    const body = encodeURIComponent(generateMessage());
    window.open(`mailto:info@domoticcontrol.com?subject=${subject}&body=${body}`);
  };

  return (
    <section id="contacto" className="contact-section">
      <div className="contact-header">
        <h2 className="contact-title">Contáctenos</h2>
        <p className="contact-subtitle">Complete el formulario y elija cómo enviar su consulta</p>
      </div>

      <div className="contact-content-container">
        <div className="contact-left-section">
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-group">
              <label htmlFor="nombre">Empresa / Razón Social</label>
              <input
                type="text"
                id="nombre"
                name="nombre"
                value={formData.nombre}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="email">Correo electrónico</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="telefono">Teléfono</label>
              <input
                type="tel"
                id="telefono"
                name="telefono"
                value={formData.telefono}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="mensaje">Mensaje / Servicio Requerido</label>
              <textarea
                id="mensaje"
                name="mensaje"
                value={formData.mensaje}
                onChange={handleChange}
                required
                className="form-textarea"
                rows="5"
              ></textarea>
            </div>
            
            {!showSendOptions ? (
              <button type="submit" className="submit-button">
                <FaPaperPlane className="button-icon" />
                ENVIAR MENSAJE
              </button>
            ) : (
              <div className="send-options">
                <p className="send-options-title">Seleccione método de envío:</p>
                <div className="send-buttons">
                  <button 
                    type="button" 
                    className="whatsapp-button"
                    onClick={sendViaWhatsApp}
                  >
                    <FaWhatsapp className="button-icon" />
                    WhatsApp
                  </button>
                </div>
              </div>
            )}
          </form>

          <div className="direct-whatsapp-container">
            <button 
              className="direct-whatsapp-button"
              onClick={() => window.open('https://wa.me/593992060337', '_blank')}
            >
              <FaWhatsapp className="button-icon" />
              Contacto directo por WhatsApp
            </button>
          </div>
        </div>

        <div className="map-right-section">
          <div className="map-address">
            <FaMapMarkerAlt className="map-marker-icon" />
            <span>Edificio Los Vergeles, Av. 12 de Abril 2-41, Cuenca 010204</span>
          </div>
          <div className="map-container">
          <iframe
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3172.9387315903796!2d-79.00245932429057!3d-2.897449539169568!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x91cd19a7e60e7fef%3A0x7a6d9f4edc12345!2sEdificio%20Los%20Vergeles%2C%20Av.%2012%20de%20Abril%202-41%2C%20Cuenca%20010204!5e0!3m2!1ses!2sec!4v1699999999999!5m2!1ses!2sec"
  width="100%"
  height="100%"
  style={{ border: 0 }}
  allowFullScreen=""
  loading="lazy"
  title="Ubicación Domotic Control - Cuenca"
/>



          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;